"use client";

import { useEffect, useState } from "react";
import { sanitizeHtml } from "@/utils/sanitize-html";

interface SanitizedHtmlProps {
  html?: string | null;
  className?: string;
}

const HtmlContentSkeleton = () => (
  <div
    aria-busy="true"
    aria-label="در حال بارگذاری محتوا"
    className="mt-4 animate-pulse space-y-3"
  >
    <div className="h-4 w-full rounded bg-gray-200" />
    <div className="h-4 w-11/12 rounded bg-gray-200" />
    <div className="h-4 w-4/5 rounded bg-gray-200" />
    <div className="h-4 w-full rounded bg-gray-200" />
    <div className="h-4 w-2/3 rounded bg-gray-200" />
  </div>
);

const BLOCK_TAG_PATTERN = /<(p|div|h[1-6]|ul|ol|li|table|blockquote|section|article|pre)\b/i;

export const SanitizedHtml = ({ html, className }: SanitizedHtmlProps) => {
  const [safeHtml, setSafeHtml] = useState("");
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setSafeHtml(sanitizeHtml(html));
    setIsReady(true);
  }, [html]);

  if (!isReady) {
    return <HtmlContentSkeleton />;
  }

  const Tag = BLOCK_TAG_PATTERN.test(safeHtml) ? "div" : "p";

  return (
    <Tag
      dangerouslySetInnerHTML={{ __html: safeHtml }}
      className={className}
    />
  );
};
